import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { liveclassschedule } from 'src/app/models/module/moduledetails';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import * as jquery from 'jquery';
import { DateFormatter } from 'src/app/models/datepickerformatterutil';
import { ToastrService } from 'ngx-toastr';
declare var $: any;


@Component({
    selector: 'app-schedulelivelesson',
    templateUrl: './schedulelivelesson.component.html',
    styleUrls: ['./schedulelivelesson.component.css']
})

export class SchedulelivelessonComponent implements OnInit {

    schedule: liveclassschedule = new liveclassschedule();
    classid: number = 0;
    scheduleid: number;
    mozilla: boolean;
    loading: boolean;
    focusmode = "focusmode";
    meetingmode = "meetingmode";
    @ViewChild('scheduleDateTimeInput') scheduleDateTimeInput: ElementRef;
    constructor(private classmanager: ClassmanagementService, private activatedroute: ActivatedRoute, private router: Router, private headerinfo: ComponentheaderService, public toastr: ToastrService) { }

    async ngOnInit() {

        this.classid = parseInt(this.activatedroute.snapshot.queryParams.classid);
        this.scheduleid = parseInt(this.activatedroute.snapshot.queryParams.scheduleid);
        this.schedule.schoolModuleClassId = this.classid;

        const lesson = await this.classmanager.getClassDetails(this.classid).toPromise();

        this.headerinfo.setHeaderDisplay('Schedule Live Lesson',
            [
                { displaytext: "School", route: `/user/schoolhome` },
                { displaytext: "Course", route: `/user/moduledetails`, params: { moduleID: lesson.moduleid } },
                { displaytext: "Lesson", route: `/user/lesson`, params: { classid: this.classid } },
                { displaytext: "Schedule Live Lesson", route: `/user/schedulelivelesson`, params: { classid: this.classid } }
            ],
            []);

        //debugger;
        if (this.scheduleid > 0) {
            this.schedule = await this.classmanager.getLiveClassSchedule(this.scheduleid).toPromise();

            // this.schedule.scheduleDateTime=

            console.log("classschedule:" + JSON.stringify(this.schedule));
        }
        else {
            this.schedule.mode = this.focusmode;
        }
    }
    // checkbrowser() {
    //   if ( $.browser.mozilla) {
    //     this.mozilla = true;
    //     console.log('mozilla is ' + this.mozilla)
    //   }
    // }

    async scheduleLiveLesson() {
        //debugger;
        var sdt = $("#scheduledatetime")[0];
        let stObj = new Date(sdt.value);
        //  let startdateobj = {
        //    year: stObj.getFullYear(),
        //    month: stObj.getMonth(),
        //    day: stObj.getDate(),
        //    hour: stObj.getHours(),
        //    minute: stObj.getMinutes(),
        //  };


        //   let st = new Date(
        //     Date.UTC(
        //       startdateobj.year,
        //       startdateobj.month,
        //       startdateobj.day,
        //       startdateobj.hour,
        //       startdateobj.minute
        //     )
        //   );

        //let st = DateFormatter.convertDate(sdt.value);

        // this.schedule.scheduleDateTime = this.scheduleDateTimeInput.nativeElement.value;
        this.schedule.scheduleDateTime = sdt.value;
        this.loading = true
        this.headerinfo.pageLoadingStarted(this, false)
        //this.toastr.info("saving...")
        console.log("Start sending emails")
        console.log(new Date().toString())
        let res: any = await this.classmanager.scheduleLiveClass(this.schedule).toPromise().catch((err) => { this.headerinfo.pageLoadingDone(this); this.loading = false; return; }).finally(() => { this.headerinfo.pageLoadingDone(this); this.loading = false });
        //this.toastr.info("Done")
        console.log(res.output);
        console.log(new Date().toString())
        console.log("Done sending emails")
        this.router.navigate(['/user/lesson'], { queryParams: { classid: this.classid } });

    }

    // cancelEdit(){

    // }

}
